module.exports = __webpack_public_path__ + "img/1728609987492-WhatsApp Image 2024-10-11 at 09.25.50.jpeg.5a3f73b7.webp";